import React from 'react';
import { XCircle, ArrowRight } from 'lucide-react';
export function PainPoints() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const pains = ['Llegás al gimnasio sin saber exactamente qué progresión vas a trabajar hoy', 'Tus alumnas no avanzan porque no hay un orden claro de contenidos ni de dificultad', 'Tenés grupos con niveles mezclados y no sabés cómo atender a todas al mismo tiempo', 'Cuando falta una nena perdés la continuidad de la progresión y no sabés cómo recuperarla', 'No podés justificar un aumento de cuota porque no tenés nada sistematizado para mostrar', 'Llegás al domingo a la noche con una hoja en blanco sin saber qué dar el lunes', 'Nadie valora tu trabajo porque los avances técnicos no se ven reflejados en resultados concretos ni en evaluaciones claras'];
  return <section className="py-20 bg-white" data-id="element-145">
      <div className="max-w-4xl mx-auto px-4" data-id="element-146">
        <div className="text-center mb-12" data-id="element-147">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-148">
            Si sos profe de gimnasia artística, esto te va a sonar conocido:
          </h2>
        </div>

        <div className="bg-red-50/50 rounded-3xl p-6 md:p-10 border border-red-100 mb-12" data-id="element-149">
          <ul className="space-y-6" data-id="element-150">
            {pains.map((pain, i) => <li key={i} className="flex items-start gap-4" data-id="element-151">
                <XCircle className="w-6 h-6 text-red-500 flex-shrink-0 mt-0.5" data-id="element-152" />
                <p className="text-gray-700 text-lg leading-relaxed" data-id="element-153">{pain}</p>
              </li>)}
          </ul>
        </div>

        <div className="text-center" data-id="element-154">
          <p className="text-2xl font-bold text-gray-900 mb-8 italic" data-id="element-155">
            "¿Cuántas clases más vas a improvisar?"
          </p>

          <button onClick={scrollToPricing} className="inline-flex items-center justify-center gap-3 bg-gray-900 hover:bg-gray-800 text-white font-bold text-lg py-4 px-8 rounded-full transition-all duration-300 transform hover:-translate-y-1 shadow-lg" data-id="element-156">
            👉 BASTA DE IMPROVISAR — QUIERO MI GIMNASIA 360
          </button>
        </div>
      </div>
    </section>;
}